import { useState } from "react";
import { ColorButton } from "../../../../common/components/button/colorButton/ColorButton";
import { showCustomConfirmDialog } from "../../../../common/components/dialogs/AppConfirmDialog";
import {
  IfFalse,
  IfTrue,
  RenderWhen,
} from "../../../../common/infrastructure/components/RenderWhen";
import { IPlannerEventUserModel } from "../models/plannerEventUserModel";
import { KeyValueItem } from "./KeyValueItem";
import styles from "./PlannerEventReservationDetailsEmails.module.scss";
import parentStyles from "./PlannerEventReservationDetails.module.scss";
import { endpointsMetadata } from "../../../../common/infrastructure/routes/endpointsMetadata";
import { useApiMutation } from "../../../../common/infrastructure/hooks/useApiMutation";

interface IPlannerEventReservationDetailsProps {
  user: IPlannerEventUserModel;
}

export const PlannerEventReservationDetailsEmails = ({
  user,
}: IPlannerEventReservationDetailsProps) => {
  const { mutateAsync } = useApiMutation();
  const [isSendingEmail, setIsSendingEmail] = useState(false);

  const onTrySendEmail = () => {
    showCustomConfirmDialog(
      "Сигурни ли сте, че искате да изпратите имейл за потвърждение на резервацията?",
      () => onSendEmail(user.userEventId),
      () => {},
      "warning",
      "Да",
      "Не"
    );
  };

  const onSendEmail = async (userEventId: number) => {
    setIsSendingEmail(true);
    try {
      await mutateAsync(
        {
          endpoint: `${endpointsMetadata.planner.sentEventEmail}`,
          globalIsLoading: false,
          method: "put",
          queryParams: { userEventId },
          invalidateKeys: [[endpointsMetadata.planner.getEvent]],
        },
        {
          onSettled: () => {
            setIsSendingEmail(false);
          },
        }
      );
    } catch (error) {
      //already handled
    }
  };

  return (
    <div className={styles.emails_content}>
      <RenderWhen condition={!!user.email}>
        <IfTrue>
          <KeyValueItem
            name={"Дадено съгласие"}
            value={user.consentedToAutomaticEmails ? "Да" : "Не"}
            tooltip="При регистрация, потребителят е задължен да даде своето съгласие дали да получава имейли от системата."
            valueClassName={
              user.consentedToAutomaticEmails
                ? styles.emails_content_consent_valid
                : styles.emails_content_consent_invalid
            }
          />
          <KeyValueItem
            name={"Изпратени имейли"}
            value={user.sentEmailsCount}
          />

          <ColorButton
            className={parentStyles.common_small_button}
            label={"Изпрати потвърдителен имейл"}
            backgroundColorHex={"#3b82f6"}
            textColorHex={"#fff"}
            onClick={onTrySendEmail}
            loading={isSendingEmail}
          />
        </IfTrue>
        <IfFalse>
          <span className={styles.emails_content_no_email}>
            Потребителят няма зададен email адрес.
          </span>
        </IfFalse>
      </RenderWhen>
    </div>
  );
};
